var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3613 2.45801C20.1113 1.58301 19.4863 0.958008 18.6113 0.708008C17.1113 0.333008 10.7363 0.333008 10.7363 0.333008C10.7363 0.333008 4.48634 0.333008 2.86134 0.708008C1.98634 0.958008 1.36132 1.58301 1.11132 2.45801C0.861324 4.08301 0.861328 7.33301 0.861328 7.33301C0.861328 7.33301 0.861332 10.583 1.23633 12.208C1.48633 13.083 2.11132 13.708 2.98632 13.958C4.48632 14.333 10.8613 14.333 10.8613 14.333C10.8613 14.333 17.1113 14.333 18.7363 13.958C19.6113 13.708 20.2363 13.083 20.4863 12.208C20.8613 10.583 20.8613 7.33301 20.8613 7.33301C20.8613 7.33301 20.8613 4.08301 20.3613 2.45801ZM8.86132 10.333V4.33301L14.1113 7.33301L8.86132 10.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1d91f8818648c3b64d2a1eef09c7b551.svg";
export { ForwardRef as ReactComponent };